<template>
  <v-checkbox
    :label="label"
    :class="computedCheckbox"
    density="comfortable"
    true-icon="mdi-check"
    false-icon=""
    :ripple="false"
    :model-value="modelValue"
    @update:model-value="updateModelValue"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { CheckboxColor } from '../../types'

const props = withDefaults(
  defineProps<{
    label?: string
    color?: CheckboxColor
    modelValue?: boolean | null
  }>(),
  {
    label: '',
    color: CheckboxColor.PRIMARY,
    modelValue: false
  }
)
const emits = defineEmits(['update:model-value'])

const computedCheckbox = computed(() => ['coco-checkbox', `coco-checkbox--${props.color}`])

function updateModelValue(value: boolean | null) {
  emits('update:model-value', value)
}
</script>

<style lang="scss">
// TODO: probably should be scoped, doesn't work rn
@import '../../styles/variables.scss';
.coco-checkbox--primary {
  .v-selection-control {
    // padding: 20px 16px;
    .v-selection-control__wrapper {
      border: 2px solid $background-quinary;
      border-radius: 6px;
      width: 24px;
      height: 24px;
    }
    .v-icon {
      font-size: 16px;
    }
  }
  .v-selection-control.v-selection-control--dirty {
    .v-selection-control__wrapper {
      color: $background-octonary !important;
      background: linear-gradient(to right, $primary-normal, $secondary-normal) !important;
      border: none !important;
    }
  }
  .v-label {
    padding-left: 8px;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: $black;
    white-space: nowrap;
  }
}
.coco-checkbox--secondary {
  .v-selection-control {
    padding: 20px 16px;
    .v-selection-control__wrapper {
      border: 2px solid $background-quinary;
      border-radius: 6px;
      width: 24px;
      height: 24px;
    }
    .v-icon {
      font-size: 16px;
    }
  }
  .v-selection-control.v-selection-control--dirty {
    .v-selection-control__wrapper {
      color: $background-octonary !important;
      background: $background-primary !important;
      border: none !important;
    }
  }
  .v-label {
    padding-left: 8px;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: $text-primary;
    white-space: nowrap;
  }
}
</style>
